import React, { Component } from 'react';
import { Row, Col, Icon, message, Statistic } from 'antd';
import { connect } from "react-redux";
import "../../asset/style/scanner/scanner.css"
import axios from "axios";
import { Link } from 'react-router-dom'
import cookie from 'react-cookies';
import { globalUrlPrefix } from '../../utils/const';

class UserControls extends Component {
    constructor(props) {
        super(props);
        this.state = {
            scan_workflow_started: false,
        }
    }

    setScanWorkflowStarted = () => {
        this.setState(Object.assign({}, this.state, { scan_workflow_started: true }));
        this.props.allowWorkflowAccess();
    }

    setScanWorkflowCancelled = () => this.setState(Object.assign({}, this.state, { scan_workflow_started: false }));

    ejectSlide = () => {
        const url = "/devices/" + this.props.id + "/eject?background=false";
        axios
        .get(url)
        .then(res => {
            message.success("Ejected successfully.")
        })
        .catch(err => {
            message.error("Eject Failed. Contact Admin");
        });
    }

    render() {
        
        var adminControls = null;
        var scanner_control = null;
        var scan_stats = null;
        var config_paths = (((this.props.device || {}).scanner_health || {}).config_paths || {});
        
        if (cookie.loadAll().superuser === "true" && !this.state.scan_workflow_started) {
            scan_stats = [
                <Row key={0}>
                    <Col span={8}>
                    </Col>
                    <Col span={8} style={{"textAlign": "center"}}>
                        <Statistic precision={2} title="Scan Disk Space Left" value={this.props.device.scanner_health.free_space} suffix="GB" />
                        <Statistic precision={2} title="Hard Disk Space Left" value={this.props.device.scanner_health.free_hdd} suffix="GB" />    
                        <Statistic title="Scans Left" value={this.props.device.scanner_health.max_scans - this.props.device.scanner_health.total_scans} />
                        <br></br>
                        <Row><b>Scanner Name : </b>{config_paths.name}</Row>
                        <Row><b>Settings File : </b>{config_paths.settings}</Row>
                        <Row><b>Optics Path : </b>{config_paths.optics}</Row>
                        <Row><b>State Path : </b>{config_paths.state}</Row>
                        <Row><b>Test Path : </b>{config_paths.test}</Row>
                    </Col>
                    <Col span={8}>
                    </Col>
                </Row>
            ];
        } 

        if (this.state.scan_workflow_started) {
            scanner_control = [
                <Row key={0} className="rounded-container">
                    <Col className="scan-workflow-init" span={24}>
                        <Row style={{ fontSize: 20, padding: 30 }} className="arial-font">Please insert slides in the cassette and place in the slot.</Row>
                        <Row style={{ padding: 30 }}>
                            <Col onClick={this.setScanWorkflowCancelled} span={4} offset={8} style={{ cursor: "pointer" }}>
                                <Row style={{ color: "#C93756" }}>
                                    <Icon type="left-circle" style={{ fontSize: 50 }} />
                                </Row>
                                <Row className="arial-font">Back</Row>
                            </Col>
                            <Link to={{ pathname: "workflow" }} style={{color:"inherit"}}>
                                <Col span={4} style={{ cursor: "pointer" }}>
                                    <Row style={{ color: "#26A65B" }}>
                                        <Icon type="check-circle" style={{ fontSize: 50 }} />
                                    </Row>
                                    <Row className="arial-font">Done</Row>
                                </Col>
                            </Link>
                        </Row>
                    </Col>
                </Row>
            ]
        } else {
            scanner_control = [
                <Row key={0} >
                    <Col span={12} offset={6}>
                        <Row className="scanner-main-control-buttons">
                            <Col span={8} onClick={this.setScanWorkflowStarted}>
                                <a className="scanner-user-controls">
                                <Row style={{color:"#22A7F0"}}><Icon type="scan" className="scanner-main-control-icon"/></Row>
                                <Row className="arial-font">Take Scan</Row>
                                </a>
                            </Col>
                            <Col span={8} onClick={this.ejectSlide}>
                                <a className="scanner-user-controls">
                                <Row style={{color:"#27ae60"}}><Icon type="inbox" className="scanner-main-control-icon"/></Row>
                                <Row className="arial-font">Eject</Row>
                                </a>
                            </Col>
                            <Col span={8}>
                                <a href={'/devices/' + this.props.id + '/settings'} className="scanner-user-controls">
                                <Row><Icon type="setting" className="scanner-main-control-icon"/></Row>
                                <Row className="arial-font">Settings</Row>
                                </a>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            ]

            if (cookie.loadAll().superuser === "true") {
                adminControls = [<Row key={0}>
                                    <Col span={12} offset={6}>
                                        <Row className="scanner-main-control-buttons">
                                            <Col span={8} offset={4}>
                                                <a href={'/devices/' + this.props.id + '/manualmode'} className="scanner-user-controls">
                                                <Row style={{color:"#d63031"}}><Icon type="sliders" className="scanner-main-control-icon"/></Row>
                                                <Row className="arial-font">Manual Mode</Row>
                                                </a>
                                            </Col>
                                            <Link className="scanner-user-controls" to={ "/" + globalUrlPrefix + "/tuning/" + this.props.id + "/"}>
                                                <Col span={8}>
                                                        <Row>
                                                            <Icon type="tool" className="scanner-main-control-icon"/>
                                                        </Row>
                                                            <Row className="arial-font">Tuning</Row>
                                                </Col>
                                            </Link>
                                        </Row>
                                    </Col>
                                </Row>, 
                                <Row key={1}>
                                    <Col span={12} offset={6}>
                                        <Row className="scanner-main-control-buttons">
                                        <Col span={8}>
                                            <a href={'/devices/' + this.props.id + '/take_last_scan/?scan_speed=FAST'} className="scanner-user-controls">
                                            <Row style={{color:"#f39c12"}}><Icon type="copy" className="scanner-main-control-icon-retake"/></Row>
                                            <Row className="arial-font">Retake Fast</Row>
                                            </a>
                                        </Col>
                                        <Col span={8}>
                                            <a href={'/devices/' + this.props.id + '/take_last_scan/?scan_speed=MEDIUM'} className="scanner-user-controls">
                                            <Row style={{color:"#f39c12"}}><Icon type="copy" className="scanner-main-control-icon-retake"/></Row>
                                            <Row className="arial-font">Retake Medium</Row>
                                            </a>
                                        </Col>
                                        <Col span={8}>
                                            <a href={'/devices/' + this.props.id + '/take_last_scan/?scan_speed=SLOW'} className="scanner-user-controls">
                                            <Row style={{color:"#f39c12"}}><Icon type="copy" className="scanner-main-control-icon-retake"/></Row>
                                            <Row className="arial-font">Retake Slow</Row>
                                            </a>
                                        </Col>
                                        </Row>
                                    </Col>
                                </Row>
                ];
            }
        }

        return (
            <Row className="rounded-container">
                <Col span={24}>
                    {scanner_control}
                    {adminControls}
                </Col>
                <Col span={24}>
                    {scan_stats}
                </Col>
            </Row>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        superuser: state.loginAlerts.superuser,
        device: state.deviceStatusReducer[ownProps.id]
    };
};

export default connect(mapStateToProps)(UserControls);
